import {
    Button,
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    Drawer,
    DrawerClose,
    DrawerContent,
    DrawerDescription,
    DrawerTitle,
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from 'shared-ui';
import { XIcon } from 'lucide-react';

import { useMediaQuery } from '@/hooks/useMediaQuery';
import { HelpContent } from '@/components/help/HelpContent';

interface HelpDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
}

export function HelpDialog({ open, onOpenChange }: HelpDialogProps) {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    if (isDesktop) {
        return (
            <Dialog open={open} onOpenChange={onOpenChange}>
                <DialogContent className="rounded-md p-6 pt-0 sm:max-w-sm" showCloseButton={false}>
                    <DialogHeader className="border-border -mx-6 flex flex-row items-center justify-between border-b px-6 py-6">
                        <DialogTitle className="text-2xl font-extrabold tracking-wide uppercase">
                            Need Help?
                        </DialogTitle>
                        <DialogDescription className="sr-only">
                            Contact the Origin support team by email or phone.
                        </DialogDescription>
                        <Tooltip>
                            <DialogClose
                                render={
                                    <TooltipTrigger
                                        render={
                                            <Button
                                                variant="ghost"
                                                size="icon-sm"
                                                className="size-10 shrink-0 rounded-md"
                                            />
                                        }
                                    />
                                }
                            >
                                <XIcon className="size-4" strokeWidth={2.25} />
                                <span className="sr-only">Close</span>
                            </DialogClose>
                            <TooltipContent side="bottom" align="center">
                                Close
                            </TooltipContent>
                        </Tooltip>
                    </DialogHeader>
                    <HelpContent />
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            <DrawerContent className="border-border border">
                <div className="relative px-6 pt-8 pb-8">
                    <div className="mb-6 flex flex-row items-center justify-between gap-4">
                        <DrawerTitle className="text-foreground text-xl leading-7 font-black tracking-normal uppercase">
                            Need Help?
                        </DrawerTitle>
                        <DrawerDescription className="sr-only">
                            Contact the Origin support team by email or phone.
                        </DrawerDescription>

                        <DrawerClose asChild>
                            <Button variant="ghost" size="icon-sm" className="size-10 shrink-0 rounded-md">
                                <XIcon className="size-4" strokeWidth={2.25} />
                                <span className="sr-only">Close</span>
                            </Button>
                        </DrawerClose>
                    </div>

                    <HelpContent />
                </div>
            </DrawerContent>
        </Drawer>
    );
}
